/* eslint-disable max-len */
export default {
  'app.title': 'C-Track Public Access',
  'app.subtitle': 'Delaware County Court of Common Pleas Civil Case Dockets and Judgment Index',
  'app.byline': 'Developed by Thomson Reuters Court Management Solutions',
  'app.user': 'Public User',

  'banner.toggleNavigation': 'Toggle banner navigation options',
  'banner.userMenu': 'User menu',

  'menu.toggleNavigation': 'Toggle main menu navigation options',

  'home.title': 'Home',
  'home.links': 'Quick Links',

  'paging.overflow': 'Results capped at {maxResults} of {totalItems} record matches.',
  'paging.noRecords': 'No records were found.',

  'login.title': 'Login',
  'login.buttons.anonLogin': 'Continue as Public User',
  'login.disclaimer': 'While every effort is made to keep information provided over the internet accurate and up-to-date, Delaware County does not certify the authenticity or accuracy of such information. No warranties, express or implied, are provided for the records and/or data contained herein, or for their use or interpretation by the User.<br><br>Delaware County, its elected officials, officers, employees, and agents assume no legal responsibilities for the information or accuracy contained in this data, including any action taken from reliance on any information contained herein and shall have no liability for any damages, losses, costs, or expenses, including, but not limited to attorney\'s fees, arising from the use or misuse of the information provided herein. The User\'s use thereof shall constitute an agreement by the User to release Delaware County, its elected officials, officers, employees and agents from such liability.<br><br>By using this system, the User is stating that the above Disclaimer has been read and that he/she has full understanding and is in agreement with the contents.',

  'logout.button': 'Logout',
  'logout.success': 'You have successfully logged out.',

  'caseView.details.associatedCases': 'Associated Cases',
  'caseView.details.caseClassification': 'Classification',
  'caseView.details.caseNumber': 'Case Number',
  'caseView.details.caseStatus': 'Case Status',
  'caseView.details.caseStatusDate': 'Status Date',
  'caseView.details.filedDate': 'Filed Date',
  'caseView.details.shortTitle': 'Title',
  'caseView.details.tags': 'Tags',

  'caseView.tab.assessments': 'Assessments',
  'caseView.tab.citations': 'Citations',
  'caseView.tab.charges': 'Charges',
  'caseView.tab.docketEntries': 'Docket Entries',
  'caseView.tab.hearings': 'Hearings',
  'caseView.tab.judgments': 'Judgments',
  'caseView.tab.lowerCourts': 'Lower Courts',
  'caseView.tab.parties': 'Parties',
  'caseView.tab.receipts': 'Receipts',
  'caseView.tab.warrants': 'Warrants',

  'caseView.summary.summary': 'Case View Summary',
  'caseView.summary.rowWarning': 'WARNING: The current view supports a maximum of {maxRows} records per table. There are {totalRows} records in this table and only the first {maxRows} are displayed. Please visit the Case View screen to access the additional records for this Case.',
  'caseView.summary.totalRecords': '{totalRows} Record(s)',
  'caseView.summary.hasDocs': 'Has Documents',

  'caseView.title': 'Case View',
  'caseView.section.details': 'Details',

  'calendar.popup.title': 'Calendar Details',
  'calendar.popup.caption': 'Hearings',
  'calendar.popup.iconSR': 'Show hearings for calendar',

  'document.download.title': 'Downloading Document',
  'document.download.message': 'Please stand by while your document is being downloaded...',

  'document.popup.title': 'Documents',
  'document.popup.name': 'Name',
  'document.popup.description': 'Description',
  'document.popup.downloadLinkHeader': 'Document',
  'document.popup.downloadLink': 'View',
  'document.popup.downloadLinkSR': 'the document',
  'document.popup.unavailable': 'Unavailable',
  'document.popup.table': 'Documents',
  'document.popup.iconSR': 'Documents',

  'error.title': 'Error',
  'error.validationTitle': 'Validation Error',
  'error.runtimeError': 'We\'re sorry, but the application has encountered a runtime error. Please reload the page and try again.',
  'error.validationError': 'Unable to process the request due to the following validation errors:',
  'error.ajaxError': 'We\'re sorry, but the application has encountered a server error. Please reload the page and try again.',
  'error.message404': 'We\'re sorry, but we were unable to find the requested URL. Please use your browser\'s back button or the main menu to return to the application.',

  'search.advanced.title': 'Advanced Search',

  'search.criteria': 'Criteria',

  'search.description': 'Click to search',

  'search.filters.title': 'Filters',
  'search.filters.hide': 'Hide Filters',
  'search.filters.show': 'Show Filters',

  'search.help.help': 'Help',
  'search.help.helpText': 'Perform a search by entering criteria into the form fields. The more information you can provide the better your search results will be. By default, the search will return results which contain the data entered.',
  'search.help.advancedText': 'For fields where a selection is available, \'Starts With\' will return results which begin with the search text. \'Contains\' will return results with the search text in any location. \'Phonetic\' will return results which sound similar - for example, a search for the name John will also return results for Jon.',

  'search.noResults': 'Your search did not match any records. Here are some things you can try:',
  'search.noResultsSuggestions': '<li>check your spelling</li><li>use fewer search criteria</li><li>expand date ranges</li>',

  'search.facet.yes': 'Yes',
  'search.facet.no': 'No',

  'search.quick.placeholder': 'Case Number',
  'search.quick.description': 'Click to Search',

  'search.range.start': '(On or After)',
  'search.range.end': '(On or Before)',
  'search.range.general': 'General',
  'search.range.past': 'Past Dates',
  'search.range.future': 'Future Dates',
  'search.range.any': 'Any Date',
  'search.range.custom': 'Custom Date Range',
  'search.range.last24Hours': 'Last 24 hours',
  'search.range.lastWeek': 'Last week',
  'search.range.lastMonth': 'Last month',
  'search.range.last3Months': 'Last 3 months',
  'search.range.last6Months': 'Last 6 months',
  'search.range.lastYear': 'Last year',
  'search.range.next24Hours': 'Next 24 hours',
  'search.range.nextWeek': 'Next week',
  'search.range.nextMonth': 'Next month',
  'search.range.next3Months': 'Next 3 months',
  'search.range.next6Months': 'Next 6 months',
  'search.range.nextYear': 'Next year',

  'search.toggleNavigation': 'Toggle search navigation controls',

  'search.types.assessment': 'Assessment Search',
  'search.types.calendar': 'Calendar Search',
  'search.types.case': 'Case Search',
  'search.types.citation': 'Citation Search',
  'search.types.charge': 'Charge Search',
  'search.types.docketEntry': 'Docket Entry Search',
  'search.types.document': 'Document Search',
  'search.types.hearing': 'Hearing Search',
  'search.types.judgment': 'Judgment Search',
  'search.types.lowerCourt': 'Lower Court Search',
  'search.types.opinion': 'Opinion Search',
  'search.types.party': 'Party Search',
  'search.types.receipt': 'Receipt Search',
  'search.types.warrant': 'Warrant Search',

  'search.results.cols.caseNumber': 'Case Number',
  'search.results.cols.calendarDate': 'Calendar Date',
  'search.results.cols.documents': 'Documents',

  'search.results.caption': 'Results',

  'search.descriptions.assessment': 'Search the system for case assessment records by party name, status, or case information.',
  'search.descriptions.calendar': 'Search the system for court calendar event records by department, courtroom, or date.',
  'search.descriptions.case': 'Search the system for case records by case number, title, status, or filed date.',
  'search.descriptions.citation': 'Search the system for citation records by party, issued date, or case information.',
  'search.descriptions.charge': 'Search the system for charge records by party, offense date, or case information.',
  'search.descriptions.docketEntry': 'Search the system for charge records by party, offense date, or case information.',
  'search.descriptions.document': 'Search the system for docket entry documents by text snippet',
  'search.descriptions.hearing': 'Search the system for case hearing records by type, hearing date, or case information.',
  'search.descriptions.judgment': 'Search the system for civil judgment records by party, status, or case information.',
  'search.descriptions.lowerCourt': 'Search the system for lower court information by number, title, or case information.',
  'search.descriptions.opinion': 'Search the system for case opinions.',
  'search.descriptions.party': 'Search the system for party records by name, type, or case information.',
  'search.descriptions.receipt': 'Search the system for receipt records by payor, date, or case information.',
  'search.descriptions.warrant': 'Search the system for warrant records by name, status, or case information.',

  'global.search': 'Search',
  'global.reset': 'Reset',
  'global.cancel': 'Cancel',
  'global.close': 'Close',
  'global.homepage': 'Homepage',
  'global.yes': 'Yes',
  'global.no': 'No',
  'global.goTo': 'Go to',
  'global.goToPage': 'Go to page',
  'global.goToFirstPage': 'Go to first page',
  'global.goToPreviousPage': 'Go to previous page',
  'global.goToNextPage': 'Go to next page',
  'global.goToLastPage': 'Go to last page',
  'global.goToCase': 'Go to case'
};
